import {AnnotationManager} from "PDFImporter/Manager/PDFManager/AnnotationManager";

export class TextAnnotation extends AnnotationManager{
    public static Generate
}